import { render, staticRenderFns } from "./CancellationLayout.vue?vue&type=template&id=17d439c4&"
import script from "./CancellationLayout.vue?vue&type=script&lang=js&"
export * from "./CancellationLayout.vue?vue&type=script&lang=js&"
import style0 from "./CancellationLayout.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports